import color from "../../../../../constants/color";

const styles = {
  noShadow:{
    boxShadow:"none"
  },
  pagination:{
    width:"100%",
    "& .MuiTablePagination-spacer":{
      display:"none"},
    "& .MuiInputBase-root":{
      border:" 1px solid #E5E5E5",
      borderRadius:"30px",
      px:1}
  },
  tableHead: {
    color: color.lightText,
    fontWeight: "400",
    whiteSpace:"nowrap"

  },
  textsize: {
    fontSize: "13px",
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400",
  },

  gridContainer: {
    display:"flex",
    flexDirection:"row",
    justifyContent: "space-between",
    alignItems: "center",
    px:2,
    pt:1
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },
  accessDisabledText: {
    color: color.lightText,
    fontSize: "12px",
    mt: "4px",
  },

  tableData: {
    borderBottom: "0",
    textTransform:"capitalize",
    whiteSpace:"nowrap"

  },
  profileData: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center" 
  },
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize",
    whiteSpace: "nowrap",

  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },
  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "center",  
  },
  deleteIcon: {
    color: "#ff0000",
    mb:1,
    ml:1,
  },
  
  
};
export default styles;